import { ConvenienceTestsConfirmParams, ConvenienceTestsConfirmResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const postConvenienceTestsConfirm = async ({
  api,
}: {
  api: AxiosInstance
  params: ConvenienceTestsConfirmParams
}): Promise<AxiosResponse<ConvenienceTestsConfirmResponse>> => {
  return api.post<ConvenienceTestsConfirmResponse>('/user/me/convenience-tests')
}
